import { useMutation, useQueryClient } from "react-query";
import { COMMON_USER_QUERY_KEY } from "./useUserQuery";

export const useUserMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ patientUserId, givenName, nickname, isAdvocating = false }) => {
      queryClient.setQueryData(COMMON_USER_QUERY_KEY, {
        patientUserId: patientUserId,
        isAdvocating: isAdvocating,
        givenName: givenName,
        nickname: nickname
      });
    },
  });
};
